function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classnames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'reactstrap';
import Icon from '../common/containers/icon';
import entityComposition from '../common/classes/entityComposition';
import { checkCanEditPermissions } from './reportSelectors';
const ReportsRow = ({
  data: {
    id,
    statusName,
    canEditReport,
    statusDate,
    preview,
    firstName,
    lastName,
    reportTypeName,
    jobNumber,
    reportNumber,
    appCreated,
    reportType
  },
  disabled: _disabled = false,
  index,
  hasActions,
  readOnly: _readOnly = false,
  isSelected,
  onEditClick,
  onSelect,
  onClick,
  user,
  isDeleted: _isDeleted = false
}) => {
  const handleEditClick = () => !_isDeleted && onEditClick(id);
  const handleSelect = event => onSelect(id, event);
  const handleClick = () => !_isDeleted && onClick(id);

  // if not editable (i.e. no content), moot point.
  const isReportBuilder = () => canEditReport;
  const isEditable = checkCanEditPermissions(user, {
    identifier: reportType
  }, {
    identifier: statusName.toLowerCase(),
    _created: statusDate
  });
  let checkbox;
  let editColumn;
  const rowClass = classnames({
    disabled: _disabled,
    deleted: _isDeleted
  }, `t-rr-${index}`);
  const rowSpan = preview ? 3 : 1;
  const colSpan = preview ? 3 : 1;
  // if preview is set create two rows to maintain striping
  const previewRow = preview ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null), /*#__PURE__*/React.createElement("tr", {
    className: `${rowClass}-preview`
  }, /*#__PURE__*/React.createElement("td", {
    colSpan: colSpan
  }, preview))) : null;
  if (isReportBuilder()) {
    // there are three cases.
    editColumn = /*#__PURE__*/React.createElement("td", {
      rowSpan: rowSpan,
      style: _objectSpread({
        verticalAlign: 'middle',
        textAlign: 'center',
        width: '30px'
      }, _isDeleted ? {
        opacity: 0.5
      } : {})
    }, isEditable && !_isDeleted && /*#__PURE__*/React.createElement(NavLink, {
      onClick: handleEditClick
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: _readOnly ? 'eye' : 'pencil-alt',
      className: "t-rr-edit"
    })));
  } else {
    editColumn = /*#__PURE__*/React.createElement("td", {
      "aria-label": "edit-report-button",
      onClick: _isDeleted ? undefined : handleClick,
      role: _isDeleted ? undefined : 'button',
      style: _isDeleted ? {
        opacity: 0.5
      } : {}
    });
  }
  if (hasActions) {
    checkbox = /*#__PURE__*/React.createElement("td", {
      "aria-label": "select-report-checkbox",
      rowSpan: rowSpan,
      style: {
        width: '1px',
        verticalAlign: 'middle'
      }
    }, /*#__PURE__*/React.createElement("input", {
      className: "t-rr-check",
      type: "checkbox",
      checked: isSelected,
      onChange: handleSelect
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: rowClass
  }, checkbox, /*#__PURE__*/React.createElement("td", {
    className: `t-rr-reportnumber t-rr-reportnumber-${reportNumber}`,
    onClick: _isDeleted ? undefined : handleClick,
    role: _isDeleted ? undefined : 'button',
    style: _isDeleted ? {
      opacity: 0.5,
      cursor: 'default'
    } : {}
  }, `${reportTypeName} ${reportNumber}`, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", null, jobNumber)), /*#__PURE__*/React.createElement("td", {
    onClick: _isDeleted ? undefined : handleClick,
    role: _isDeleted ? undefined : 'button',
    style: _isDeleted ? {
      opacity: 0.5,
      cursor: 'default'
    } : {}
  }, `${firstName} ${lastName}`, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", null, moment(appCreated).format('MM/DD/YYYY'))), /*#__PURE__*/React.createElement("td", {
    onClick: _isDeleted ? undefined : handleClick,
    role: _isDeleted ? undefined : 'button',
    style: _isDeleted ? {
      opacity: 0.5,
      cursor: 'default'
    } : {}
  }, /*#__PURE__*/React.createElement("span", {
    className: `t-rr-${index}-statusName`,
    style: statusName === 'Rejected' ? {
      color: 'red'
    } : {}
  }, statusName), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", null, moment(statusDate).format('MM/DD/YYYY'))), editColumn), previewRow);
};
ReportsRow.propTypes = {
  data: PropTypes.shape({
    appCreated: PropTypes.string,
    canEditReport: PropTypes.number,
    firstName: PropTypes.string,
    id: PropTypes.string,
    jobNumber: PropTypes.string,
    lastName: PropTypes.string,
    preview: PropTypes.string,
    reportNumber: PropTypes.number,
    reportType: PropTypes.string,
    reportTypeName: PropTypes.string,
    statusName: PropTypes.string,
    statusDate: PropTypes.string
  }).isRequired,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  hasActions: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isDeleted: PropTypes.bool,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  user: PropTypes.shape({
    permissions: PropTypes.shape({}),
    user_id: PropTypes.string
  }).isRequired
};
export { ReportsRow as TestReportsRow };
export default entityComposition(ReportsRow, [], {
  user: state => state.login.user
}, []);